import Landing from '../locales/en/Landing.json';
import NewsLetter from '../locales/en/NewsLetter.json';
import FooterLinks from '../locales/en/FooterLinks.json';
import Footer from '../locales/en/Footer.json';
import Navbar from '../locales/en/Navbar.json';
import TextPanel from '../locales/en/TextPanel.json';
import AboutUs from '../locales/en/AboutUs.json';
import Teams from '../locales/en/Teams.json';
import ContactUs from '../locales/en/ContactUs.json';
import Awards from '../locales/en/Awards.json';
import OceanProtocol from '../locales/en/OceanProtocol.json';
import MsTeams from '../locales/en/MsTeams.json';
import Login from '../locales/en/Login.json';
import Classroom from '../locales/en/Classroom.json';
import ProfileDropDown from '../locales/en/ProfileDropDown.json';
import Profile from '../locales/en/Profile.json';
import NavbarDashboard from '../locales/en/NavbarDashboard.json';
import MyVideos from '../locales/en/MyVideos.json';
import LibraryItem from '../locales/en/LibraryItem.json';
import ScenesPanel from '../locales/en/ScenesPanel.json';
import MusicPanel from '../locales/en/MusicPanel.json';
import PublishPanel from '../locales/en/PublishPanel.json';
import Goals from '../locales/en/Goals.json';
import Privacy from '../locales/en/Privacy.json';
import VideoConference from '../locales/en/VideoConference.json';
import ClassLanding from '../locales/en/ClassLanding.json';
import studio from '../locales/en/Studio.json';
import grammer from '../locales/en/Grammer.json';
import changelog from '../locales/en/Changelog.json';
import Metamasklogin from '../locales/en/Metamasklogin.json';
import Verification from '../locales/en/Verification.json';
import GoogleLogin from '../locales/en/GoogleLogin.json';

export default {
  Landing,
  NewsLetter,
  FooterLinks,
  Footer,
  Navbar,
  TextPanel,
  AboutUs,
  Teams,
  ContactUs,
  Awards,
  OceanProtocol,
  MsTeams,
  Login,
  Classroom,
  ProfileDropDown,
  Profile,
  NavbarDashboard,
  MyVideos,
  LibraryItem,
  ScenesPanel,
  MusicPanel,
  PublishPanel,
  Goals,
  Privacy,
  VideoConference,
  ClassLanding,
  studio,
  grammer,
  changelog,
  Metamasklogin,
  Verification,
  GoogleLogin

  /*studio: {
    errors: {
      e1: 'Your browser does not support the video tag.'
    },
    sidebarPanel: {
      sp1: 'Script',
      sp2: 'Library',
      sp3: 'Format',
      sp4: 'Course',
      sp5: 'Sound',
      sp6: 'Publish',
      sp7: 'Add a video script and create scenes',
      sp8: 'Select videos for your script',
      sp9: 'Choose a video format',
      sp10: 'Prepare your scenes/course',
      sp11: 'Add voice/narration to your scenes/course',
      sp12: 'Storage',
      text: {
        t1: 'When you create scenes, they will appear here'
      },
      library: {
        l1: 'When you create scenes, video suggestions will appear here',
        l2: 'Scene',
        l3: 'Select one video to continue',
        l4: 'Select one image to continue',
        l5: 'Upload video to continue',
        l6: 'Search Videos...',
        l7: 'Search Images...'
      },
      format: {
        f1: 'Aspect Ratio',
        f2: 'Resolution'
      },
      course: {
        c1: 'Prepare All Scenes',
        c2: 'Your browser does not support the video tag.',
        c3: 'Skip this step'
      },
      voice: {
        v1: 'Skip this step'
      },
      publish: {
        p1: 'Publish Panel'
      }
    },
    text: {
      t1: 'Create A Video',
      t2: 'Video Title',
      t3: 'Video Description',
      t4: 'Video Script',
      t5: 'Enter Your Video Script here...',
      t6: 'Create Scenes!!!'
    },
    course: {
      c1: 'Script Position',
      c2: 'Text',
      c3: 'BG',
      c4: 'Edit scene script',
      c5: 'Add Text Overlay to Scene'
    },
    voice: {
      v1: 'Start Recording',
      v2: 'Upload & Add Voice',
      v3: 'Stop recording',
      v4: 'Try Again'
    },
    publish: {
      p1: 'Publish',
      p2: 'Published'
    }
  },
  grammer: {
    connectWallet: 'Connect Wallet',
    disconnect: 'Disconnect',
    login: 'Login',
    createVideo: 'Create a Video',
    title: 'Title',
    description: 'Description',
    video: 'Video',
    createScenes: 'Create Scenes',
    text: 'Text',
    upload: 'Upload',
    url: 'URL',
    script: 'Script',
    library: 'Library',
    course: 'Cousre',
    sound: 'Sound',
    publish: 'Publish',
    uploadTitle: 'Upload a PPT or PDF File',
    uploadLabel: 'Choose a file or drag it here',
    urlTitle: 'Create Video From URL',
    urlText: 'Enter your URL Here',
    urlType: 'You can submit medium Link & blog Link etc',
    urlPlaceholder: 'Paste URL here',
    go: 'Go',
    guideTitle: 'How it Works',
    textDescription: `Copy paste your script into the video script box alongwith a
    suitable title in the video title . Click Create Scenes to
    breakdown your script into video snippets.`,
    uploadDescription: `Directly convert a ppt or pdf file into a video by choosing
    the file and dragging it in the box.`,
    urlDescription: `Copy paste the URL of an external blog post or newletter and
    change them into a video content`,
    spitTypeShort: 'Short Scenes',
    spitTypeLong: 'Long Scenes',
    libraryTabDesc: 'Select one media to continue',
    scene: 'Scene',
    scenes: 'Scenes',
    videos: 'Videos',
    images: 'Images',
    uploads: 'Uploads',
    search: 'Search',
    uploadSceneMedia: 'Upload Media',
    courseTabDesc: 'You can add subtitle to your videos',
    skipStep: 'Skip this step',
    subtitles: 'Subtitles',
    animation: 'Animation',
    editScript: 'Edit Scene Script',
    addSubtitle: 'Add Text Overlay to Scene',
    add: 'Add',
    delete: 'Delete',
    remove: 'Remove',
    soundTabDesc: 'You can add Sound to your videos',
    narration: 'Narration',
    music: 'Music',
    startRecording: 'Start Recording',
    audio: 'Audio',
    voice: 'Voice',
    tags: 'Tags',
    access: 'Access',
    free: 'Free',
    paid: 'Paid',
    preview: 'Preview',
    note: 'Note',
    previewNote:
      'This is a low quality video for rendering purposes only, when your are ready, extract a high quality video by publishing it',
    download: 'Download',
    enter: 'Enter',
    select: 'Select',
    track: 'Track',
    noTrack: 'No track selected',
    genre: 'Genre',
    yes: 'Yes',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    previewAgainText: 'Do you want to generate the Preview again ?',
    previewLoading: 'Generating Preview...',
    beforeLibraryAlert: 'Add a video script and create scenes',
    beforeCourseAlert: 'Select videos for your script',
    beforeSoundAlert: 'Prepare your scenes/course',
    beforePublishAlert: 'Add voice/narration to your scenes/course',
    transaction: 'Transaction',
    processing: 'Processing',
    processingWarning: `Please don't close this tab, transaction under processing.`,
    retry: 'Retry',
    failed: 'Failed',
    rejected: 'Rejected',
    txModal: {
      publish: {
        processing: [
          {
            title: 'Create a Content ID',
            description:
              'Assign a unique identifier to your content. Write it on decentralized ledger.',
            success: 'Data-Token is created'
          },
          {
            title: 'Publish on MarketPlace',
            description:
              'Publishing the asset on marketplace with your unique Decentralized ID (called a DID or DDO)',
            success: 'Asset published to OCEAN'
          },
          {
            title: 'Create link for Paid Access',
            description:
              ' Creating access tokens for the published content, using which people will buy/fork your content.',
            success: 'Tokens Minted'
          },
          {
            title: 'Permission to sell your content',
            description:
              'Note that we published content under your name with full rights to the content. Hence we need your permission to sell the access token on your behalf.',
            success: 'Approved'
          },
          {
            title: 'Create Exchange Key',
            description: 'Creating an exchange to sell the access token',
            success: 'Exchange Created. Publish Complete'
          }
        ],
        rejected: [
          {
            title: 'Aborting Data Token creation',
            description: ''
          },
          {
            title: 'Publishing rejected',
            description: ''
          },
          {
            title: 'Minting of tokens was rejected',
            description: ''
          },
          {
            title: 'Exchange was not approved',
            description: ''
          },
          {
            title: 'Exchange creation was rejected',
            description: ''
          }
        ],
        failed: [
          {
            title: 'Failed to create data-token. Aborting creation',
            description: ''
          },
          {
            title: 'Publishing Failed.',
            description: ''
          },
          {
            title: 'No tokens will be minted',
            description: ''
          },
          {
            title: 'Exchange was not approved',
            description: ''
          },
          {
            title: 'Exchange failed to create',
            description: ''
          }
        ]
      },
      buy: {
        processing: [
          {
            title: 'Permission to exchange your OCEAN tokens',
            description:
              'We need your permission so that we can exchange your OCEAN tokens for the datatokens',
            success: 'Approved'
          },
          {
            title: 'Swaping your token',
            description: 'Calling smart contract to exchange the tokens',
            success: 'Token Swapped'
          }
        ],
        rejected: [
          {
            title: 'Permission Denied by the user',
            description: ''
          },
          {
            title: 'Swap rejected by the user',
            description: ''
          }
        ],
        failed: [
          {
            title: 'Exchange failed',
            description: ''
          },
          {
            title: 'Swap failed',
            description: ''
          }
        ]
      },
      download: {
        processing: [
          {
            title:
              'Start download service and sign the transaction to start the download process',
            description:
              'Register your account to the download service and if already registered, sign using metamask to authenticate your account.',
            success: 'Download Started'
          }
        ],
        rejected: [
          {
            title: 'Transaction Rejected, aborting the service',
            description: ''
          }
        ],
        failed: [
          {
            title: 'Starting the download service failed',
            description: ''
          }
        ]
      }
    },
    error: {
      sentenceDetection: 'Sentence Detection',
      keywordExtraction: 'Keyword Extraction',
      videoListing: 'Video Listing',
      upload: '',
      addSubtitle: 'subtitle merge failed',
      videoSearch: 'No Videos Found',
      imageSearch: 'No Images Found',
      addVoice: 'audio merge failed',
      publish: 'video publish failed',
      concat: 'video concat failed',
      saveVideo: 'video save failed',
      download: 'download failed'
    },
    success: {
      publish: '',
      save: '',
      download: ''
    }
  },
  changelog: {
    title: 'Changelog',
    lbl0_opt0: 'All entries',
    lbl0_opt1: 'New',
    lbl0_opt2: 'Improved',
    lbl0_opt3: 'Fixed'
  }*/
};
